<template>
    <div class="stickyBar">
        <div class="list_container">
            <div v-for="(item, index) in listData" :key="index" @click="setActiopFunGroup(item)" class="centerAlign">
                <div class="group_item">
                    <img :src="item.customIcon" alt="">
                </div>
                <div class="group_name"
                    :style="{ color: item.id === activeItem ? '#fff' : '', fontWeight: item.id === activeItem ? '800' : '', }">
                    {{ $t(item.name) }}</div>
                <div :class="item.id === activeItem ? 'activeItem' : 'defaultItem'"></div>
            </div>
        </div>
    </div>

    <div v-if="showGameList">
        <GamePopup ref="gameListRef" />
    </div>
</template>

<script setup lang="ts">
import { GroupList, setActiveItemFromClick, setFirstActiveItem } from '@/view/home/supportScript';
import { ref, onMounted, computed, onBeforeMount, watch, nextTick } from 'vue'
import GamePopup from '@/view/game/gamePopup.vue';

const customStyles = ref({
    active_background_color: '',
    active_font_color: "",
    border_color: "",
    font_color: ""
})
const props = defineProps<{
    listData: GroupList[],
    itemData: {
        styles: {
            active_background_color: string,
            active_font_color: string,
            border_color: string,
            font_color: string
        }
    },
}>()
const localActiveItem = ref<string | number>('')
const gameListRef = ref()
const showGameList = ref(false)

const activeItem = computed({
    get: () => localActiveItem.value || props.listData[0]?.id || '',
    set: (val) => {
        localActiveItem.value = val
    }
})
const emits = defineEmits(['showGameList'])

const hexWithAlpha = (hex: string, alpha: number) => {
    return hex + Math.round(alpha * 255).toString(16).padStart(2, '0')
}
const color1 = computed(() => customStyles.value.active_background_color)
const color2 = computed(() => hexWithAlpha(color1.value, 0))
const color3 = computed(() => hexWithAlpha(color1.value, 0.5))
const color4 = computed(() => hexWithAlpha(color1.value, 0.04))

const setActiopFunGroup = async (item: any) => {
    setActiveItemFromClick(item, localActiveItem)
    await nextTick()
    gameListRef.value?.selectGroup(item)
}

const setActiveItem = () => {
    setFirstActiveItem(props.listData, localActiveItem)
}
watch(activeItem, async (val) => {
    if (activeItem.value != props.listData[0].id) {
        showGameList.value = true
    } else {
        showGameList.value = false
    }
    emits('showGameList', showGameList.value)
})
defineExpose({
    setActiveItem,
    setActiopFunGroup
})

onBeforeMount(() => {
    setActiveItem();
});

onMounted(() => {
    customStyles.value.active_background_color = props.itemData.styles.active_background_color
    customStyles.value.active_font_color = props.itemData.styles.active_font_color
    customStyles.value.border_color = props.itemData.styles.border_color
    customStyles.value.font_color = props.itemData.styles.font_color
})
</script>
<style scoped>
.list_container {
    display: flex;
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
    overflow-x: auto;
    scrollbar-width: none !important;
    transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
    transition-property: transform;
    transition-duration: 0ms;
    margin: 15px 0 0;
    background: #131826;
    padding: 15px 15px 0;
    border-radius: 10px;

}

.stickyBar {
    background-color: #090f1f;
    position: sticky;
    top: 118px;
    z-index: 99;
    margin: 0;
    padding: 0 15px;
}

.list_container::-webkit-scrollbar {
    display: none;
}

.group_item {
    flex-direction: column;
    position: relative;
    margin: 0 3px 0;
    padding: 10px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    width: 30px;
    height: 25px;
}

.group_item img {
    max-width: 100%;
    opacity: 0.7;
}

.group_name {
    text-align: center;
    font-size: 14px;
    padding-top: 5px;
    color: #fff;
}

.activeItem {
    width: 15px;
    height: 3px;
    border-radius: 30px;
    background: #94FF7F;
    box-shadow: var(--box-shadow, 0 0 .25rem 0 var(--ep-color-icon-selected, #94FF7F));
    margin-top: 10px;
}

.defaultItem {
    width: 15px;
    height: 3px;
    margin-top: 10px;
}

.centerAlign {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 0 10px
}
</style>